// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3ycTC","list":"BalanceDue_list__18UFd","listRow":"BalanceDue_listRow__25Slm","total":"BalanceDue_total__12lH3"};